export const I18n = {
	'en': {
		deleteAll: 'Delete All',
		addAll: 'Add All',
		appName: 'App name'
	},
	'ru': {
		deleteAll: 'Удалить все',
		addAll: 'Добавить все',
		appName: 'Название Приложения'
	},
	'sk': {
		deleteAll: 'Vymazať všetko',
		addAll: 'Pridať všetko',
		appName: 'Názov aplikácie'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/checkedAppsList/index.js